import React from "react";
import { Navigate, useLocation } from "react-router-dom";

export default function ProtectedRoute({
  user,
  allowedRoles,
  children,
  requireProfileComplete = false,
}) {
  const location = useLocation();

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  if (allowedRoles?.length && !allowedRoles.includes(user.role)) {
    if (user.role === "doctor") return <Navigate to="/dashboard/doctor/appointments" replace />;
    if (user.role === "pharmacy") return <Navigate to="/dashboard/pharmacy" replace />;
    if (user.role === "insurer") return <Navigate to="/dashboard/insurer" replace />;
    if (user.role === "admin") return <Navigate to="/dashboard/admin" replace />;
    return <Navigate to="/dashboard" replace />;
  }

  if (
    requireProfileComplete &&
    user?.role === "pharmacy" &&
    !user?.profileCompleted &&
    location.pathname !== "/dashboard/pharmacy/profile"
  ) {
    return <Navigate to="/dashboard/pharmacy/profile" replace />;
  }

  return children;
}